import React, { useEffect, useState } from "react";
import { Modal } from "./common";
import { useLang } from "../i18n";
import api, { apiError } from "../api";
import { toast } from "sonner";

export default function EnableStudentLoginModal({ open, onClose, onDone, student }) {
  const { t, pick } = useLang();
  const [username, setUsername] = useState("");
  const [busy, setBusy] = useState(false);
  const [credentials, setCredentials] = useState(null);

  useEffect(() => {
    if (open) {
      setUsername("");
      setCredentials(null);
    }
  }, [open]);

  if (!student) return null;

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/staff/students/${student.id}/enable-login`, { username });
      setCredentials(data);
      toast.success(t("teacher.login_enabled"));
      onDone?.();
    } catch (error) {
      toast.error(apiError(error, t));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open={open} onClose={() => !busy && onClose()} title={t("teacher.enable_login")}
      testId="enable-student-login-modal">
      {credentials ? (
        <div className="text-center space-y-4">
          <p className="text-lg font-extrabold text-[#48D276]">{t("teacher.login_enabled")}</p>
          <div className="rounded-2xl bg-[#0D0B38]/60 border border-[#FFC83D]/30 p-4" dir="ltr">
            <p data-testid="enabled-login-username" className="font-black text-lg">
              {credentials.username}
            </p>
            <p data-testid="enabled-login-password" className="font-black text-lg text-[#FFC83D]">
              {credentials.temp_password}
            </p>
          </div>
          <button data-testid="enable-login-done-btn" onClick={onClose}
            className="btn-magic w-full">
            {t("common.close")}
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          <p data-testid="enable-login-student-name" className="font-extrabold">
            {pick(student, "name")}
          </p>
          <div>
            <label className="text-sm font-extrabold block mb-1">
              {t("teacher.username_optional")}
            </label>
            <input data-testid="enable-login-username-input" className="input-magic" dir="ltr"
              value={username} onChange={(event) => setUsername(event.target.value)} />
          </div>
          <p className="text-xs text-[#A5A0D6]">{t("teacher.username_auto_hint")}</p>
          <button data-testid="enable-login-submit-btn" disabled={busy} onClick={submit}
            className="btn-magic w-full">
            {busy ? t("common.loading") : t("teacher.enable_login")}
          </button>
        </div>
      )}
    </Modal>
  );
}